import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, HostListener, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FadvBaseComponent, Forward, Track, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/pagination/pagination';

class FadvPaginationComponent extends FadvBaseComponent {
    constructor() {
        super(...arguments);
        this.currentPage = 1;
        this.totalPages = 1;
        this.delta = 2;
        this.groupingThreshold = 5;
        this.currentPageChange = new EventEmitter();
        this.pageChanged = new EventEmitter();
    }
    _forwardPageChange(event) {
        const detail = event === null || event === void 0 ? void 0 : event.detail;
        this.pageChanged.emit(detail);
        this.currentPageChange.emit(detail.currentPage);
        event.stopPropagation();
    }
    gotoPage(page) {
        var _a, _b;
        (_b = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.gotoPage(page);
    }
    gotoFirstPage() {
        var _a, _b;
        (_b = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.gotoFirstPage();
    }
    gotoLastPage() {
        var _a, _b;
        (_b = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.gotoLastPage();
    }
    gotoNextPage() {
        var _a, _b;
        (_b = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.gotoNextPage();
    }
    gotoPreviousPage() {
        var _a, _b;
        (_b = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.gotoPreviousPage();
    }
}
FadvPaginationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvPaginationComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FadvPaginationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvPaginationComponent, selector: "fadv-pagination", inputs: { currentPage: "currentPage", totalPages: "totalPages", delta: "delta", groupingThreshold: "groupingThreshold", breakpoint: "breakpoint", hoist: "hoist" }, outputs: { currentPageChange: "currentPageChange", pageChanged: "pageChanged" }, host: { listeners: { "fadv-page-change": "_forwardPageChange($event)" } }, usesInheritance: true, ngImport: i0, template: '', isInline: true });
__decorate([
    Forward()
], FadvPaginationComponent.prototype, "currentPage", void 0);
__decorate([
    Forward()
], FadvPaginationComponent.prototype, "totalPages", void 0);
__decorate([
    Forward()
], FadvPaginationComponent.prototype, "delta", void 0);
__decorate([
    Forward()
], FadvPaginationComponent.prototype, "groupingThreshold", void 0);
__decorate([
    Forward()
], FadvPaginationComponent.prototype, "breakpoint", void 0);
__decorate([
    Forward()
], FadvPaginationComponent.prototype, "hoist", void 0);
__decorate([
    Track()
], FadvPaginationComponent.prototype, "pageChanged", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvPaginationComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-pagination',
                    template: '',
                }]
        }], propDecorators: { currentPage: [{
                type: Input
            }], totalPages: [{
                type: Input
            }], delta: [{
                type: Input
            }], groupingThreshold: [{
                type: Input
            }], breakpoint: [{
                type: Input
            }], hoist: [{
                type: Input
            }], currentPageChange: [{
                type: Output
            }], pageChanged: [{
                type: Output
            }], _forwardPageChange: [{
                type: HostListener,
                args: ['fadv-page-change', ['$event']]
            }] } });

class FadvPaginationModule {
}
FadvPaginationModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvPaginationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvPaginationModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvPaginationModule, declarations: [FadvPaginationComponent], imports: [FadvCommonModule], exports: [FadvPaginationComponent] });
FadvPaginationModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvPaginationModule, imports: [FadvCommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvPaginationModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvPaginationComponent],
                    imports: [FadvCommonModule],
                    exports: [FadvPaginationComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvPaginationComponent, FadvPaginationModule };
